import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draft-invoice-downloader container-fluid mt-2" }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = { class: "row justify-content-between downloader-ui-row" }
const _hoisted_4 = { class: "col-6-md col-sm mx-n2 progress-wrap-col" }
const _hoisted_5 = { class: "progress-frame" }
const _hoisted_6 = { class: "text-center message-div align-self-center" }
const _hoisted_7 = { class: "wrap-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col text-center h4",
        style: _normalizeStyle({fontSize: _ctx.FontSizes.large1})
      }, "全請求書ZIPファイル ", 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "progress-base" }, null, -1)),
          _createElementVNode("div", {
            class: "progress-bar",
            style: _normalizeStyle({width: _ctx.progressBarWidth()})
          }, null, 4)
        ], 512), [
          [_vShow, _ctx.invoiceProcess.status === _ctx.invoiceProcessStatuses.ON_PROCESS
                            || _ctx.downloadingState !== _ctx.zipDownloadState.OUT_OF_PROCESS]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.messageText()), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["col-3-md col-sm card", {'card-disabled': !_ctx.canClickPrepareButton()}]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPreparePDFZip && _ctx.onClickPreparePDFZip(...args)))
      }, _toDisplayString(_ctx.prepareButtonText()), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["col-3-md col-sm card", {'card-disabled': !_ctx.canClickDownloadButton()}]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickDownloadAllInvoicePDFZip && _ctx.onClickDownloadAllInvoicePDFZip(...args)))
      }, _toDisplayString(_ctx.downloadButtonText()), 3)
    ])
  ]))
}